import { render, staticRenderFns } from "./workDay_block.vue?vue&type=template&id=19dc4ed7&scoped=true"
import script from "./workDay_block.vue?vue&type=script&lang=js"
export * from "./workDay_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc4ed7",
  null
  
)

export default component.exports